// EmployeeFormComponent.js - Komponente für das Mitarbeiter-Formular
import React from 'react';

/**
 * @typedef {Object} EmployeeFormProps
 * @property {Object} employee - Die Mitarbeiterdaten
 * @property {Function} onInputChange - Callback für Änderungen am Formular
 * @property {Function} onSubmit - Callback für das Absenden des Formulars
 * @property {boolean} loading - Zeigt an, ob gerade geladen wird
 */

/**
 * Komponente für das Formular zur Bearbeitung von Mitarbeiterdaten
 * 
 * @param {EmployeeFormProps} props - Die Eigenschaften der Komponente
 */
const EmployeeFormComponent = ({ employee, onInputChange, onSubmit, loading }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-xl font-bold mb-4">Mitarbeiterdaten</h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="employeeId" className="block text-sm font-medium text-gray-700 mb-1">
              Mitarbeiter-ID
            </label>
            <input
              type="text"
              id="employeeId"
              name="employeeId"
              value={employee.employeeId || ''}
              onChange={onInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              required
              disabled
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              E-Mail
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={employee.email || ''}
              onChange={onInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
              Vorname
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={employee.firstName || ''}
              onChange={onInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              required
            />
          </div>
          <div>
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
              Nachname
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={employee.lastName || ''}
              onChange={onInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              required
            />
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="contractualAverageWorkingTime" className="block text-sm font-medium text-gray-700 mb-1">
              Wöchentliche Arbeitszeit (Stunden)
            </label>
            <input
              type="number"
              id="contractualAverageWorkingTime"
              name="contractualAverageWorkingTime"
              value={employee.contractualAverageWorkingTime || ''}
              onChange={onInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              step="0.5"
              min="0"
              max="60"
            />
          </div>
          <div>
            <label htmlFor="annualVacationDays" className="block text-sm font-medium text-gray-700 mb-1">
              Urlaubstage pro Jahr
            </label>
            <input
              type="number"
              id="annualVacationDays"
              name="annualVacationDays"
              value={employee.annualVacationDays || ''}
              onChange={onInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              min="0"
              max="50"
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="bg-primary text-white py-2 px-6 rounded-lg hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-primaryLight transition"
            disabled={loading}
          >
            {loading ? 'Wird gespeichert...' : 'Speichern'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmployeeFormComponent;
